import { useState } from "react";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

export interface Template {
    template?: string;
    name?: string;
    isSaved?: boolean | false;
}

const UploadTemplate: React.FunctionComponent<{ onUploadTemplate: any }> = (props) => {

    const [isModalOpen, setIsModalOpen] = useState<boolean>(false);
    const { t } = useTranslation();
    const [template, setTemplate] = useState<Template>({ isSaved: false });
    const [isSave, setIsSave] = useState<boolean>(false);

    const handleSave = () => {
        setIsSave(true);
        setIsModalOpen(false);
        props.onUploadTemplate(template).then(() => {
            setTemplate({});
            setIsSave(false);
        }).catch(() => {
            setTemplate({});
            setIsSave(false);
        });
    };

    const handleChangeCheck = () => {
        setTemplate((prev) => ({ ...prev, isSaved: !prev.isSaved }));
    }
    const handleChange = (event: any) => {
        const { name, value } = event.target;
        setTemplate((prev: any) => ({ ...prev, [name]: value }));
    };

    return (
        <div>
            <button className="button-reset border-746AFF color-746AFF back-trans padd-15 marg-right-16" onClick={() => setIsModalOpen(true)}>
                <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3.3125 16H12.6875C13.4629 16 14.0938 15.3692 14.0938 14.5938V4.6875H10.8125C10.0371 4.6875 9.40625 4.05669 9.40625 3.28125V0H3.3125C2.53706 0 1.90625 0.630813 1.90625 1.40625V14.5938C1.90625 15.3692 2.53706 16 3.3125 16ZM5.1875 6.59375H10.8125C11.0716 6.59375 11.2812 6.80341 11.2812 7.0625C11.2812 7.32159 11.0716 7.53125 10.8125 7.53125H5.1875C4.92841 7.53125 4.71875 7.32159 4.71875 7.0625C4.71875 6.80341 4.92841 6.59375 5.1875 6.59375ZM5.1875 8.46875H10.8125C11.0716 8.46875 11.2812 8.67841 11.2812 8.9375C11.2812 9.19659 11.0716 9.40625 10.8125 9.40625H5.1875C4.92841 9.40625 4.71875 9.19659 4.71875 8.9375C4.71875 8.67841 4.92841 8.46875 5.1875 8.46875ZM5.1875 10.3438H10.8125C11.0716 10.3438 11.2812 10.5534 11.2812 10.8125C11.2812 11.0716 11.0716 11.2812 10.8125 11.2812H5.1875C4.92841 11.2812 4.71875 11.0716 4.71875 10.8125C4.71875 10.5534 4.92841 10.3438 5.1875 10.3438ZM5.1875 12.2188H8.9375C9.19659 12.2188 9.40625 12.4284 9.40625 12.6875C9.40625 12.9466 9.19659 13.1562 8.9375 13.1562H5.1875C4.92841 13.1562 4.71875 12.9466 4.71875 12.6875C4.71875 12.4284 4.92841 12.2188 5.1875 12.2188Z" fill="#6366F1" />
                    <path d="M3.3125 16H12.6875C13.4629 16 14.0938 15.3692 14.0938 14.5938V4.6875H10.8125C10.0371 4.6875 9.40625 4.05669 9.40625 3.28125V0H3.3125C2.53706 0 1.90625 0.630813 1.90625 1.40625V14.5938C1.90625 15.3692 2.53706 16 3.3125 16ZM5.1875 6.59375H10.8125C11.0716 6.59375 11.2812 6.80341 11.2812 7.0625C11.2812 7.32159 11.0716 7.53125 10.8125 7.53125H5.1875C4.92841 7.53125 4.71875 7.32159 4.71875 7.0625C4.71875 6.80341 4.92841 6.59375 5.1875 6.59375ZM5.1875 8.46875H10.8125C11.0716 8.46875 11.2812 8.67841 11.2812 8.9375C11.2812 9.19659 11.0716 9.40625 10.8125 9.40625H5.1875C4.92841 9.40625 4.71875 9.19659 4.71875 8.9375C4.71875 8.67841 4.92841 8.46875 5.1875 8.46875ZM5.1875 10.3438H10.8125C11.0716 10.3438 11.2812 10.5534 11.2812 10.8125C11.2812 11.0716 11.0716 11.2812 10.8125 11.2812H5.1875C4.92841 11.2812 4.71875 11.0716 4.71875 10.8125C4.71875 10.5534 4.92841 10.3438 5.1875 10.3438ZM5.1875 12.2188H8.9375C9.19659 12.2188 9.40625 12.4284 9.40625 12.6875C9.40625 12.9466 9.19659 13.1562 8.9375 13.1562H5.1875C4.92841 13.1562 4.71875 12.9466 4.71875 12.6875C4.71875 12.4284 4.92841 12.2188 5.1875 12.2188Z" fill="black" fillOpacity="0.2" />
                    <path d="M10.8125 3.75H13.8191L10.3438 0.274658V3.28125C10.3438 3.53988 10.5539 3.75 10.8125 3.75Z" fill="#6366F1" />
                    <path d="M10.8125 3.75H13.8191L10.3438 0.274658V3.28125C10.3438 3.53988 10.5539 3.75 10.8125 3.75Z" fill="black" fillOpacity="0.2" />
                </svg>
                {t("propertyDetails.uploadTemplate")}
                {isSave && <div className="spinner-border text-primary size-20" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>}
            </button>


            <BootstrapDialog
                onClose={() => setIsModalOpen(false)}
                aria-labelledby="customized-dialog-title"
                open={isModalOpen}
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogTitle id="customized-dialog-title">
                    <div className="title-24"> {t("propertyDetails.insertTemplate")} </div>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setIsModalOpen(false)}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[500],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent >

                    <textarea className="para-14 bold-500 color-727272 mb-3 form-control textarea back-trans"
                        dir="auto" id="descValue" rows={4} name="template" onChange={handleChange} value={template.template} cols={40} />

                    <div className="form-check mb-3 ">
                        <input className="form-check-input" type="checkbox" onChange={handleChangeCheck} name="isSaved" checked={template.isSaved} />
                        <label className="form-check-label" htmlFor="defaultCheck2" style={{ cursor: "pointer" }}>
                            Save as a template
                        </label>
                    </div>

                    <label className="form-label-1 mb-3" htmlFor="selectTypeOpt">Template Name</label>
                    <input type="text" className={`form-input border-CBD5E1`} placeholder={"e.g. Villa Showcase"} name="name" onChange={handleChange} />

                </DialogContent>
                <DialogActions>
                    <button type="button" className="button-dash back-EEF2FF border-trans color-475569 mb-2 padd-15" onClick={() => setIsModalOpen(false)}>
                        {t("propertyDetails.cancel")}
                    </button>
                    <button type="button" className="button-dash back-6366F1 border-6366F1 color-FFFFFF mb-2 padd-15" onClick={handleSave}>
                        Match style
                    </button>
                </DialogActions>
            </BootstrapDialog>


        </div>
    )

}
export default UploadTemplate;